module.exports = __webpack_public_path__ + "static/media/rich14.312478c0.JPG";